export default __webpack_public_path__ + "static/media/landingInfographic2.046b29f3.png";